export const SET_ENTRIES = 'SET_ENTRIES'
export const SET_ENTRY = 'SET_ENTRY'
export const UPDATE_ENTRY = 'UPDATE_ENTRY'
export const INIT_ENTRY = 'INIT_ENTRY'



// WEBPACK FOOTER //
// ./src/store/modules/admin/logging/types.js